import React, { useEffect, useState } from 'react';
import { HomeOutlined,DeleteOutlined } from '@ant-design/icons';
import { Col, Row, Breadcrumb, Tabs, Input, message, Form, Button, Modal } from 'antd';
import './index.less';
import Layout, { Content } from 'antd/lib/layout/layout';
import '@wangeditor/editor/dist/css/style.css';//css
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import { IDomEditor, IEditorConfig, IToolbarConfig, i18nChangeLanguage } from '@wangeditor/editor';
import {
    submitFeedback
} from '../../../redux/reducer/feedback';
import { sendFeedBack } from '../../../util/Request';
import { IFeedbackModel, IFileContent } from '../../../util/Request/requestType';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
i18nChangeLanguage('en');//Set language

export default function Feedback() {
    //Start editor
    // Eitor example
    const [editor, setEditor] = useState<IDomEditor | null>(null);

    // Editor content
    const [html, setHtml] = useState('');

    // Simulate Ajax requests and set HTML asynchronously
    useEffect(() => {
        setTimeout(() => {
            setHtml('');
        }, 1500);
    }, []);

    //Tool configuration
    const toolbarConfig: Partial<IToolbarConfig> = {};

    //Editor configuration
    const editorConfig: Partial<IEditorConfig> = {
        placeholder: 'Here is your description of feedback/request',
    };

    // It is important to destroy editor in time!
    useEffect(() => {
        return () => {
            if (editor == null) return;
            editor.destroy();
            setEditor(null);
        };
    }, [editor]);
    //Exclude some menus
    toolbarConfig.excludeKeys = [
        'codeBlock', 'undo', 'redo', 'color', 'bgColor', 'fontSize', 'fontFamily', 'lineHeight', 'emotion', 'group-image', 'divider', 'todo', 'group-justify', 'group-indent',
        'insertTable', 'underline',
        'group-video',
        'group-more-style',// Exclude the menu group and write the value of the menu group key
        'fullScreen'
    ];
    //End editor
    const dispatch = useDispatch();
    const [typeID, setTypeID] = useState('1');
    const [feedbackSubject, setFeedbackSubject] = useState('');
    const [isChosenFile, setIsChosenFile] = useState('No file chosen');
    //Tabs item
    const items = [
        {
            label: 'Left feedback',
            key: '1',
            style: { fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', width: '100%', lineHeight: '16px' }
        },
        {
            label: 'Request information',
            key: '2',
            style: { fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' },
        },
        {
            label: 'Report issue',
            key: '3',
            style: { fontFamily: 'Noto-Sans', fontSize: '12px', color: '#696F88', lineHeight: '16px' }
        },
    ];
    const callback = async (key) => {
        setTypeID(key);
    };
    const inputFeedback = (e) => {
        setFeedbackSubject(e.target.value);
    };
    const filetypes = ['.JPG', '.PNG', '.GIF', '.BMP', '.JPEG', '.TIFF', '.PSD', '.SVG', '.DOC', '.DOCX', '.PPT', '.PPTX', '.XLS', '.XLSX', '.PDF'];
    //upload img
    const fileUploadLimit = 5 * 1024 * 1024; // 1MB in bytes. Formula: 1MB = 1 * 1024 * 1024.
    const [imageCollection, setImageCollection] = React.useState([] as any[]);
    const [fileContent, setFileContent] = React.useState([] as IFileContent[]);
    const renderImage = (imageObj, files) => {
        const newImageCollection = [...imageCollection];
        if (newImageCollection.length < 5) {
            //Judge whether it is duplicate attachment
            const tmp = newImageCollection.filter(x => x.props.children[0].key == imageObj.fileName);
            if (tmp.length > 0) {
                return;
            }
            newImageCollection.push(
                <li style={{ listStyle: 'none' }} key={imageObj.timestamp}>
                    <span className='fileTitle' key={imageObj.fileName} >{imageObj.fileName}</span>
                    <span onClick={e => setDeleteItem(imageObj.timestamp)} style={{ float: 'right' }}><DeleteOutlined /></span>
                </li>);
            const tmpFileObject: IFileContent = {
                fileKey: imageObj.timestamp,
                fileContent: files
            };
            const tmpFile = [...fileContent];
            tmpFile.push(tmpFileObject);
            setFileContent([...tmpFile]);
        }
        setImageCollection([...newImageCollection]);
    };
    //Add Image
    const addImage = (imageObj) => {
        //File number limit: 5
        const newImageCollection = [...imageCollection];
        if (newImageCollection.length > 4) {
            message.error('File number limit: 5');
            return;
        }
        //get upload file Suffix
        const uploadFileName = (imageObj.fileName.substring(imageObj.fileName.lastIndexOf('.'))).toUpperCase();
        //Judge whether it is an allowed file type
        if (!filetypes.includes(uploadFileName)) {
            message.error('Allowed file types: Word, Excel, PPT, PDF, Image(JPG/JPEG/PNG/GIF/SVG/BMP/TIFF/PSD)');
            setImageCollection([...imageCollection.filter(x => x.key != imageObj.timestamp)]);
            setFileContent([...fileContent.filter(x => x.fileKey != imageObj.timestamp)]);
            return;
        }
        //Judge the file size limit
        if (imageObj.fileSize === 0) {
            message.error('File size is 0MB');
            setImageCollection([...imageCollection.filter(x => x.key != imageObj.timestamp)]);
            setFileContent([...fileContent.filter(x => x.fileKey != imageObj.timestamp)]);
            return;
        }
        if (imageObj.fileSize > fileUploadLimit) {
            message.error('Single file size limit: 5MB');
            setImageCollection([...imageCollection.filter(x => x.key != imageObj.timestamp)]);
            setFileContent([...fileContent.filter(x => x.fileKey != imageObj.timestamp)]);
            return;
        }
        ////Judge whether it is duplicate attachment
        const tmp = newImageCollection.filter(x => x.props.children[0].key == imageObj.fileName);
        if (tmp.length > 0) {
            message.error('Do not add duplicate attachments');
            return;
        }
        return true;
    };
    //Delete file
    const [deleteItem, setDeleteItem] = useState('');
    useEffect(() => {
        const newImageCollection = [...imageCollection];
        if (newImageCollection.length === 1) {
            setIsChosenFile('No file chosen');
        }
        //remove image from page
        setImageCollection([...imageCollection.filter(x => x.key != deleteItem)]);
        //remove from fileContent
        setFileContent([...fileContent.filter(x => x.fileKey != deleteItem)]);
    }, [deleteItem]);
    //Change file
    const changeUrl = async (e: any) => {
        const file = e.target.files[0];
        //console.log('filefile', e);
        const files = e.target.files;
        if (file != undefined) {
            setIsChosenFile('');
            // Create an object containing image information.
            const imageObj = {
                fileName: file.name,
                fileSize: file.size,
                fileType: file.type,
                timestamp: Date.now()
            };
            //render to page
            renderImage(imageObj, files);
            // Add To Local storage
            addImage(imageObj);
        }
    };
    const submitFeedbackToBack = async () => {
        if (feedbackSubject == '' || html == '' || html === '<p><br></p>') {
            message.warn('Please enter mandatory values!');
            return;
        }
        const submitFeedbackParam: IFeedbackModel = {
            files: fileContent,
            feedbackType: typeID,
            feedbackSubject: feedbackSubject,
            content: html
        };
        //console.log("content ", submitFeedbackParam);
        const response = await sendFeedBack(submitFeedbackParam);
        dispatch(submitFeedback({
            feedbackList: response
        }));
        if (response === 'Success') {
            Modal.success({
                content: 'The feedback has be logged. We will contact you as soon as possible!',
                centered: true,
                onOk() {
                    window.open('/home', '_self');
                },
            });
        }
    };
    return (
        <div className="feedback">
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col className="gutter-row" span={16} >
                    <Breadcrumb>
                        <Breadcrumb.Item href="">
                            <Link to="/home" > <HomeOutlined /></Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Feedback</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ marginTop: '20px' }} >
                        <Form>
                            <p className="submitFont">Submit Request / Feedback</p>
                            <p className="commonStyle">Feedback type <span className="red">*</span></p>
                            <Tabs onChange={callback} type="card" className="tab-soil" items={items} />
                            <div>
                                <p className="commonStyle">Subject <span className="red">*</span></p>
                                <Input style={{ height: '40px' }} onChange={inputFeedback} value={feedbackSubject} />
                                <p className="commonStyle">Description <span className="red">*</span></p>
                                {/*Start editor*/}
                                <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
                                    <Toolbar
                                        editor={editor}
                                        defaultConfig={toolbarConfig}
                                        mode="default"
                                        style={{ borderBottom: '1px solid #ccc' }}
                                    />
                                    <Editor
                                        defaultConfig={editorConfig}
                                        value={html}
                                        onCreated={setEditor}
                                        onChange={editor => setHtml(editor.getHtml())}
                                        mode="default"
                                        style={{ height: '301px', overflowY: 'hidden' }}
                                    />
                                </div>
                                {/*End editor*/}
                                <p className="commonStyle">Attachments (optional)<br />
                                    <label style={{ fontSize: '12px', color: 'red', fontFamily: 'Arial' }} >
                                        File number limit: 5, Single file size limit: 5MB, Allowed file types: Word, Excel, PPT, PDF, Image
                                    </label>
                                </p>
                                <label htmlFor='image-upload' style={{
                                    backgroundColor: '#efefef', border: '1px solid grey',
                                    padding: '2px 8px', marginRight: '6px', borderRadius: '2px'
                                }} >Choose Files</label><span>{isChosenFile}</span>
                                <input type="file" id='image-upload' style={{ color: '#14151C', display: 'none' }}
                                    accept=".pptx,.ppt,.xls,.xlsx,.docx,.doc,.PDF,.JPG,.JPEG,.PNG,.GIF,.SVG,.BMP,.TIFF,.PSD"
                                    onChange={changeUrl} />
                                <ul id="image-collection" style={{ width: '30%', padding: '10px 8px 8px 8px' }} >
                                    {imageCollection}
                                </ul>
                                <div className="buttonMargin">
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit"
                                            id="buttonStyle"
                                            onClick={submitFeedbackToBack}
                                            style={{
                                                color: '#FFF',
                                                height: '40px',
                                                verticalAlign: 'baseline',
                                                backgroundColor: '#59B948',
                                                borderRadius: '24px!important',
                                                padding: '4px 35px'
                                            }}
                                        >Submit</Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Col>
                <Col className="gutter-row" span={8}>
                    <div>
                        <Layout>
                            <Content style={{ padding: '60px' }} >
                                <p className="titleFont">Contact information</p>
                                <div className="contactPartStyle">
                                    <div className="contactItemStyle">
                                        <p className="nameFont">Kethireddy Pradeep CHBS</p>
                                        <p className="roleFont">Platform Manager</p>
                                        <a href='mailto:pradeep.kethireddy@syngenta.com?subject=My feedback'><p className="mailFont">pradeep.kethireddy@syngenta.com</p></a>
                                    </div>
                                    <div className="contactItemStyle">
                                        <p className="nameFont">Irene Caramatti CHBS</p>
                                        <p className="roleFont">Environmental Data analyst</p>
                                        <a href='mailto:irene.caramatti@syngenta.com?subject=My feedback'><p className="mailFont">irene.caramatti@syngenta.com</p></a>
                                    </div>
                                </div>
                            </Content>
                        </Layout>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
